import _ from 'lodash';
import { FeaturePermission } from '../../../../constants/feature.permission.helper';
import api from '../../../../scripts/api';
import { translate, translateText } from '../../../../scripts/core/tools/translate';
import environment from '../../../../scripts/environment';
const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

export class StorePlannedFilterFactory {
    constructor({ options, currentMap }) {
        this.options = options;
        this.currentMap = currentMap;
    }

    getData() {
        const data = [];

        if (_.size(environment.get('CONFIG.STATES')) > 1) {
            data.push({
                name: 'state',
                position: 6,
                visible: true,
                fields: [{
                    title: translate('Common.State'),
                    name: 'state',
                    dataSource: environment.get('CONFIG.STATES'),
                    value: 'value',
                    text: 'text',
                    skipAll: true,
                    type: 'multiselect'
                }]
            });
        }

        if (_.size(environment.get('CONFIG.FILTERS.GROUPS_WITH_PLANNED_STORES')) > 1) {
            data.push({
                name: 'groupsPlannedStore',
                position: 7,
                visible: true,
                fields: [{
                    title: translate('Common.Groups'),
                    name: 'groupsPlannedStore',
                    dataSource: environment.get('CONFIG.FILTERS.GROUPS_WITH_PLANNED_STORES'),
                    value: 'value',
                    text: 'text',
                    skipAll: true,
                    type: 'multiselect'
                }]
            });
        }

        return data.filter(c => c.visible);
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/storePlanned.factory.js